<template>
    <div>
        <v-dialog scrollable max-width="1200px" v-model="showDialog">
            <template v-slot:activator="{ on }">
                    <v-btn v-on="on">CONSULTAR CENSOS</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <h4>Consultar censos</h4>
                </v-card-title>
                <v-card-text>
                    <v-text-field type=text label="Nombre del socio" v-model="valorBusqueda" autofocus
                        @keyup.enter="buscar" />

                    <v-data-table :headers="headers" :items="censos" :loading="loading">
                        <template v-slot:[`item.faltantes`]="props">
                            <ul class="red--text">
                                <li v-if="!props.item.direccion || props.item.direccion.length < 2">direccion</li>
                                <li v-if="!props.item.localidad || props.item.localidad.length < 2">localidad</li>
                                <li v-if="!props.item.cedula || props.item.cedula.length < 1">cedula</li>
                                <li v-if="!props.item.feVida || props.item.feVida.length < 10">fe vida</li>
                                <!-- <li v-if="!props.item.logFeVida">fe vida</li> -->
                            </ul>
                        </template>
                        <template v-slot:[`item.actions`]="props">
                            <v-btn v-if="props"
                                :disabled="loading || props.item.estado == 'CENSADO' || (props.item.usuario != null && props.item.estado == 'PENDIENTE')"
                                small class="mr-2" color="primary" @click="censarLocal(props.item)">Censado</v-btn>
                        </template>
                    </v-data-table>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="info" @click="volver">Volver</v-btn>
                    <v-btn color="info" @click="buscar">LEER</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



<script>


import axios from "axios";

export default {
    props: ["censado"],
    data() {
        return {
            headers: [
                { text: "CodMem", value: "codMemSq" },
                { text: "MemType", value: "memType" },
                { text: "Celular", value: "celular" },
                { text: "Nombres", value: "nombreCompleto" },
                { text: "Estado", value: "estado" },
                { text: "Usuario", value: "usuario" },
                { text: "Fecha", value: "fechaCierre" },
                { text: "Observacion", value: "observacion" },
                { text: "Accion", value: "actions", sortable: false },
            ],

            censos: [],
            errorMessage: "",
            showDialog: false,
            loading: false,
            valorBusqueda: ''
        };
    },
    mounted() {
        // this.iniciar();
    },
    methods: {
        async buscar() {
            this.loading = true;
            const res = await axios.get('censo/find?valor=' + this.valorBusqueda);
            this.censos = res.data;
            this.loading = false;
        },
        volver() {
            this.valorBusqueda = '';
            this.showDialog = false;
        },
        censarLocal(item) {
            this.censado(item);
            this.showDialog = false;
            this.censos = [];
        }

    },
}

</script>